// extracted by mini-css-extract-plugin
export default {"container":"ContactHistoryDialog_container__I540S","row":"ContactHistoryDialog_row__92tbO","activeBadge":"ContactHistoryDialog_activeBadge__TV0Gl"};